module.exports = __webpack_public_path__ + "static/media/plowtruck.a15a155e.png";